import React from "react";

const Reviews = () => {

  React.useEffect(() => {
    window.scrollTo(0,0)
  }, [])

  

  return (
    <div className="p-4 md:p-10">
      <div>
        <h1 className="text-center capitalize">Reviews</h1>
      </div>

      <div className="py-10 grid md:grid-cols-3 place-items-center gap-6">
        
      </div>
    </div>
  );
};

export default Reviews;
